import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DefaultPathView = ({ path }) => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(path);
    });

    return null;
};

export default DefaultPathView;
